import type { StaticImageData } from "next/image";
import avatarNidhi from "@/app/assets/images/testimonials/avatar-nidhi.png";
import avatarMale from "@/app/assets/images/testimonials/avatar-male.png";

export type TestimonialItem = {
    quote: string;
    name: string;
    role: string;
    avatar: StaticImageData;
};

/**
 * Testimonials fold copy — Figma web 2745:21026 / mobile 2541:30640
 * Edit this list to refresh marquee / carousel cards.
 * Avatars: Nidhi — Figma 7508:115440; male — existing photo asset.
 */
export const TESTIMONIALS_NEW: TestimonialItem[] = [
    {
        quote: "These guys have a good track record, so it was a no-brainer for me to invest about 4 lakhs in their first issue. I'll also recommend to my family & friends to invest.",
        name: "Nidhi Agarwal",
        role: "Startup founder",
        avatar: avatarNidhi,
    },
    {
        quote: "All information required for me to invest has been laid out in a transparent manner. Webinar has helped me take an informed decision.",
        name: "Nidhi Agarwal",
        role: "Startup founder",
        avatar: avatarNidhi,
    },
    {
        quote: "These guys have a good track record, so it was a no-brainer for me to invest about 4 lakhs in their first issue. I'll also recommend to my family & friends to invest.",
        name: "Lakshminarayanan Iyer",
        role: "Investor",
        avatar: avatarMale,
    },
    {
        quote: "All information required for me to invest has been laid out in a transparent manner. Webinar has helped me take an informed decision.",
        name: "Lakshminarayanan Iyer",
        role: "Investor",
        avatar: avatarMale,
    },
];

export const TESTIMONIAL_STATS = [
    { value: "1.5L+", label: "INVESTORS" },
    { value: "10L+", label: "APP DOWNLOADS" },
] as const;
